import { render, staticRenderFns } from "./NewTHGUser.vue?vue&type=template&id=6be8b017"
import script from "./NewTHGUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewTHGUser.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports